
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockApproveSetAssembleGrid extends Serenity.EntityGrid<IcStockApproveSetAssembleRow, any> {
        protected getColumnsKey() { return IcStockApproveSetAssembleColumns.columnsKey; }
        protected getDialogType() { return IcStockApproveSetAssembleDialog; }
        protected getIdProperty() { return IcStockApproveSetAssembleRow.idProperty; }
        protected getInsertPermission() { return IcStockApproveSetAssembleRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockApproveSetAssembleRow.localTextPrefix; }
        protected getService() { return IcStockApproveSetAssembleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        // protected getColumns() {
        //     var columns = super.getColumns();
    
        //     columns.splice(1, 0, {
        //         id: 'Print CountApprove',
        //         field: null,
        //         name: '',
        //         cssClass: 'align-center',
        //         format: ctx => {
        //             return '<a class="inline-action print-countapprove" title="countapprove">' +
        //             '<i class="fa fa-file-pdf-o text-red"></i></a>';
        //         },
        //         width: 30,
        //         minWidth: 30,
        //         maxWidth: 30
        //     });
    
        //     return columns;
        // }
    
        // protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //     super.onClick(e, row, cell);
    
        //     // if (e.isDefaultPrevented())
        //     //     return;
    
        //     var item = this.itemAt(row);
        //     var target = $(e.target);

            
        //     if (target.parent().hasClass('inline-action'))
        //         target = target.parent();
    
        //     if (target.hasClass('inline-action')) {
        //         e.preventDefault();
    
        //         if (target.hasClass('print-countapprove')) {
        //             const request = this.getView().params as IcStockApproveReportData
        //             request.SysDocNo = item.SysDocNo
        //             Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                    
        //             ;
        //         }
        //     }
        // }
        
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        } 
        // protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

        //     let filters = super.getQuickFilters();
        //     Q.first(filters, x => x.field == fld.ApproveFg).init = w => {
        //         (w as Serenity.EnumEditor).value = "0";
        //         ;
        //     };
    
            
    
        //     return filters;
        // }
            
        
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcStockApproveSetAssembleService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }

    }
}